import { useState } from "react";
import { Link2, Paperclip } from "lucide-react";
import { PillRail, Pill } from "@/components/common/Segmented";

// Document file names used in links and downloads: Invoice_S003015-01.pdf, Proposal_P1234.pdf, …
export const docFilename = (kind, number, ext = "pdf") =>
  `${kind}_${String(number || "").trim().replace(/[^A-Za-z0-9._-]+/g, "-") || "document"}.${ext}`;

// Short links and review pages accept a trailing file name, so the URL reads like a direct document link.
export const withDocName = (url, filename) =>
  (url && /\/api\/r\/|\/(co|wo|proposal)-review\//.test(url) ? `${url.replace(/\/$/, "")}/${filename}` : url);

// "link" = put the document URL in the email · "attach" = download the PDF now, the email says it's attached.
const KEY = "email-doc-mode";
export const getEmailDocMode = () => (localStorage.getItem(KEY) === "attach" ? "attach" : "link");
export function useEmailDocMode() {
  const [mode, set] = useState(getEmailDocMode);
  return [mode, (m) => { localStorage.setItem(KEY, m); set(m); }];
}

export function EmailDocMode({ mode, onChange, filename, testId = "email-doc-mode" }) {
  return (
    <div className="space-y-1" data-testid={testId}>
      <PillRail>
        <Pill on={mode === "link"} onClick={() => onChange("link")} testId={`${testId}-link`} title="Email a direct link to the document">
          <Link2 className="w-3 h-3" /> Send link
        </Pill>
        <Pill on={mode === "attach"} onClick={() => onChange("attach")} testId={`${testId}-attach`} title="Download the PDF now and attach it to the email">
          <Paperclip className="w-3 h-3" /> Download &amp; attach
        </Pill>
      </PillRail>
      <div className="text-[11px] text-slate-500">
        {mode === "attach" ? <>Downloads <span className="font-mono">{filename}</span> now — attach it to the email your mail app opens.</>
          : <>The email carries a direct link named <span className="font-mono">{filename}</span>.</>}
      </div>
    </div>
  );
}
